<template>
	<div>
		<div class="login">
			<div class="frame">
				<div class="btn-frame">
					<Button class="btn" @click="login">登录</Button>
					<Button class="btn" @click="information">录入个人信息</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	baseUrl,
	ssoUrl,
} from '@/config/env.js'
import {
	mapState,
	mapMutations,
	mapActions
} from 'vuex'
export default {
	data() {
		return {
		}
	},
	created() {
		this.$nextTick(function() {
			this.initData()
		})
	},
	mounted() {

	},
	watch:{

	},
	mixins:[],
	components: {
	},
	computed: {
		...mapState({
		}),
	},
	methods: {
		...mapActions([
		]),
		async initData(){
		},
		login(){
			let redirect;
            if (process.env.NODE_ENV === 'development') {
				redirect = escape(`http://localhost:8888/#/home`)
            } else {
				redirect = escape(`${baseUrl}/client/index.html#/home`);
            }
            location.href = `${ssoUrl}/sso/index.html#/hklogin?from=hk&redirect=${redirect}`;
		},
		information(){
			this.$router.push('/information');
		},
	},
}
</script>

<style lang='scss' scoped>
@import '@/style/common';
@import '@/style/mixin';
.login{
	width: 100%;
	height: 100vh;
	background: url('./HKPCOrder.png') no-repeat;
	background-size: 100% 100%;
	.frame{
		width: 450px;
		height: 250px;
		background: white;
		position: relative;
		top: 240px;
    	left: 60%;
		box-shadow: 1px 3px 20px 0 rgb(0 0 0 / 20%);
		.btn-frame{
			width: 100%;
			padding-top: 100px;
			text-align: center;
			.btn{
				width: 150px;
				height: 40px;
				margin: 0 20px;
				color: white;
				background: #bc86c8;
			}
		}
	}
}
</style>